import { render, staticRenderFns } from "./MemberDashboard.vue?vue&type=template&id=00d2bf38&scoped=true"
import script from "./MemberDashboard.vue?vue&type=script&lang=js"
export * from "./MemberDashboard.vue?vue&type=script&lang=js"
import style0 from "./MemberDashboard.vue?vue&type=style&index=0&id=00d2bf38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d2bf38",
  null
  
)

export default component.exports